<template>
	<div
		v-if="showComponent"
		:class="['ao-file-input-avatar-wrapper', `size-${size}`, { 'v-input--error': error }]"
	>
		<div
			v-if="files.length"
			class="actions"
		>
			<ao-icon-btn
				size="24"
				variant="flat"
				iconName="delete"
				@click="handleRemoveFile"
			/>
		</div>
		<div
			v-else
			class="cover cursor-pointer position-absolute"
		>
			<ao-icon
				class="bulk-icon"
				iconName="imageBulk"
			/>
			<ao-icon
				class="upload-icon mt-3"
				iconName="cloudUpload"
			/>
			<div class="upload">Загрузить изображение</div>
		</div>
		<template
			v-if="hasUrlFile"
		>
			<v-img
				v-if="componentIsCalledFromDialogFormMaster"
				:src="modelValue"
				contain
				:aspect-ratio="1"
				class="rounded-circle"
			/>
			<img
				v-else
				class="mr-4 filepond--item"
				:src="modelValue"
				alt=""
			>
		</template>
		<FilePond
			v-else
			ref="filepond"
			:files="files"
			:server="getServerOptions"
			:credits="null"
			:allowRevert="false"
			:allowRemove="false"
			:allowProcess="false"
			name="avatar-pond"
			accepted-file-types="image/jpeg, image/png"
			maxFileSize="3000000"
			@updatefiles="handleUpdateFiles"
			@init="handleFilePondInit"
		/>
		<div
			class="v-input__details pa-0 mt-n2"
			:class="files.length && 'mt-n6'"
		>
			<div class="v-messages">
				<div
					v-if="error && errorMessages"
					class="v-messages__message"
				>
					<span v-if="!Array.isArray(errorMessages)">{{ errorMessages }}</span>
					<span v-else-if="!Array.isArray(errorMessages[0])">{{ errorMessages[0] }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vueFilePond from 'vue-filepond'
import { useUserStore } from '@/stores/userStore'
import { mapState } from 'pinia'
const FilePond = vueFilePond()

export default {
	name: 'AoFileInputAvatar',

	components: {
		FilePond,
	},

	props: {
		modelValue: [Array, String, Blob],
		size: {
			type: String,
			default: 'default',
		},
		error: {
			type: Boolean,
			default: true,
		},
		errorMessages: {
			type: [Array, String],
		},
		urlForUpload: {
			type: String,
			default: 'files/',
		},
		componentIsCalledFromDialogFormMaster: {
			type: Boolean,
			default: false,
		},
	},

	emits: ['update:modelValue'],

	data() {
		return {
			showComponent: true,
			hasUrlFile: false,
			files: [
				// {
				// 	source: 'https://cdn.create.vista.com/api/media/small/367565514/stock-photo-top-view-white-dove-symbol',
				// 	options: {
				// 		type: 'local',
				// 	},
				// }
			],
			apiUrl: import.meta.env.VITE_APP_BACK_API_URL,
		}
	},
	computed: {
		...mapState(useUserStore, ['getAuthToken']),
		getServerOptions() {
			return {
				process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
					const formData = new FormData()
					formData.append('file', file, file.name)
					const request = new XMLHttpRequest()
					request.open('POST', `${this.apiUrl}/${this.urlForUpload}`)
					request.setRequestHeader('Authorization', `Bearer ${this.getAuthToken}`)
					request.upload.onprogress = (e) => {
						progress(e.lengthComputable, e.loaded, e.total)
					}
					request.onload = () => {
						if (request.status >= 200 && request.status < 300) {
							load(request.responseText)
							let response = JSON.parse(request.response)
							this.files.push(response)
							this.$emit('update:modelValue', response.id)
						} else {
							error('error send file')
						}
					}
					request.send(formData)
					return {
						abort: () => {
							request.abort()

							abort()
						},
					}
				},
				load: (source, load) => {
					const myRequest = new Request(source)
					fetch(myRequest).then(function (response) {
						response.blob().then(function (myBlob) {
							load(myBlob)
						})
					})
				},
				revert: (file, load) => {
					let fileData = JSON.parse(file)
					let fileId = fileData.files[0].id
					let deleteUrl = fileData.files[0].deleteUrl
					const request = new XMLHttpRequest()
					request.open('POST', `${this.apiUrl}/ajax-file-upload/v1/delete/${fileId}/`)
					request.setRequestHeader('Authorization', `Bearer ${this.getAuthToken}`)
					request.onload = () => {
						if (request.status >= 200 && request.status < 300) {
							load(request.responseText)
							let response = JSON.parse(request.response)
							if (response) {
								// const index = this.imagesIds.findIndex((item) => item === fileId)
								// this.imagesIds.splice(index, 1)
								// this.$emit('update:modelValue', this.imagesIds)
							}
						} else {
							error('error revert file')
						}
					}
					request.send()
					return {
						abort: () => {
							request.abort()

							abort()
						},
					}
				},
			}
		},
	},
	watch: {
		modelValue(val) {
			this.onChangeModelValue(val)
		},
	},
	mounted() {
		if (this.componentIsCalledFromDialogFormMaster) this.onChangeModelValue(this.modelValue)
	},
	methods: {
		onChangeModelValue(val) {
			//this.showComponent = false
			const urlRegex = /(https?:\/\/[^\s]+)/g
			if (val && val.length && urlRegex.test(val)) {
				this.files.push({
					source: this.modelValue,
					options: {
						type: 'local',
					},
				})
				this.hasUrlFile = true
				// this.$nextTick(() => {
				// 	this.showComponent = true
				// })
			}
		},
		handleRemoveFile() {
			if (this.$refs.filepond) {
				this.$refs.filepond.removeFile()
			}
			this.files = []
			this.$emit('update:modelValue', 0)
			this.hasUrlFile = false
		},
		handleUpdateFiles(items) {},
		handleUploadFile() {
			this.imageActionButtonsDisabled = true
			this.$refs.filepond.processFile()
		},
		handleFilePondInit() {},
	},
}
</script>

<style lang="scss">
.ao-file-input-avatar-wrapper {
	position: relative;
	min-width: 172px;
	width: 172px;
	height: 172px;

	.actions {
		position: absolute;
		z-index: 1000;
		left: 50%;
		bottom: 16px;
		transform: translateX(-50%);
		display: flex;
		gap: 4px;
		font-size: 15px;
		color: black;
	}

	&.size-default {
		min-width: 172px !important;
		width: 172px !important;
		height: 172px;

		.cover {
			min-width: 172px;
			width: 172px;
			height: 172px;
		}

		.filepond--item {
			width: 172px;
			height: 172px !important;
		}

		.filepond--browser {
			height: 172px;
		}

		.filepond--image-PreviewWrapper {
			width: 172px;
			height: 172px;
		}

		.filepond--wrapper {
			min-height: 172px;
		}

		.filepond--panel-root {
			width: 172px;
		}
	}

	.cover {
		margin-right: 16px;
		border: 1px solid #e1e2e9;
		border-radius: 100px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.upload {
			font-family: Inter, sans-serif;
			padding: 0 20px;
			text-align: center;
			text-wrap: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 15px;
			color: #1ba092;
			margin-top: 4px;
		}

		.bulk-icon {
			font-size: 54px;
		}

		.upload-icon {
			font-size: 16px;
		}
	}

	.filepond--image-PreviewWrapper {
		border-radius: 50%;
	}

	.filepond--panel-root {
		background: transparent;
	}

	.filepond--item {
		border-radius: 50%;
		border: 1px solid #e1e2e9;
	}

	.filepond--drop-label {
		display: none;
	}

	.filepond--file-info {
		display: none;
	}

	.filepond--root .filepond--list-scroller {
		margin: 0;
	}

	.filepond--item-panel {
		display: none;
	}

	.filepond--item-panel {
		border-radius: 2em;
	}

	.filepond--list.filepond--list {
		left: 0;
	}

	.filepond--item {
		margin: 0;
	}
}
</style>
